import { styled } from "@compiled/react";

import { colorCSS, fontSizes } from "../../styles";

export const StyledMarkdown = styled.div({
    "p": {
        "marginBlockEnd": "0.75rem",
        "margin-block-end": "0.75rem"
    },
    "p:last-child": {
        "marginBlockEnd": 0,
        "margin-block-end": 0
    },
    "ol, ul": {
        "textAlign": "left",
        "text-align": "left",
        "marginBlockStart": "0.5rem",
        "margin-block-start": "0.5rem",
        "marginBlockEnd": "0.75rem",
        "margin-block-end": "0.75rem",
        "paddingInlineStart": "1.5rem",
        "padding-inline-start": "1.5rem",
        "p": {
            margin: 0
        }
    },
    "li": {
        "marginBlockEnd": "0.25rem",
        "margin-block-end": "0.25rem"
    },
    "li:last-child": {
        "marginBlockEnd": 0,
        "margin-block-end": 0
    },
    "blockquote": {
        "display": "inline-block",
        "fontSize": fontSizes.lg,
        "lineHeight": 1.5,
        "marginBlockEnd": "1rem",
        "> *": {
            "marginBlockStart": "1rem",
            "marginInlineStart": "4.5rem",
            "marginInlineEnd": "1rem",
            "@media (max-width: 576px)": {
                "marginBlockStart": "0.7rem",
                "margin-block-start": "0.7rem",
                "marginInlineStart": "4rem",
                "margin-inline-start": "4rem",
                "marginBlockEnd": "1rem",
                "margin-block-end": "1rem"
            }
        },
        "&::before": {
            "position": "absolute",
            "color": colorCSS("T400"),
            "content": '"\u201C"',
            "fontWeight": 300,
            "fontSize": "6.5rem",
            "marginBlockStart": "-0.8rem",
            "@media (max-width: 576px)": {
                "fontSize": "5.5rem",
                "font-size": "5.5rem",
                "marginBlockStart": "-1rem",
                "margin-block-start": "-1rem"
            }
        }
    },
    "table": {
        "backgroundColor": colorCSS("N0"),
        "color": colorCSS("N900"),
        "display": "block",
        "fontSize": fontSizes.sm,
        "marginBlockEnd": "1.5rem",
        "overflowX": "auto",
        "width": "100%",
        "th": {
            "backgroundColor": colorCSS("N20"),
            "background-color": colorCSS("N20")
        },
        "th, td": {
            "border": `1px solid ${colorCSS("N40")}`,
            "padding": "0.33rem 0.5rem",
            "verticalAlign": "top",
            "vertical-align": "top"
        }
    }
});
